import React from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Header } from "../styles";
import { MenuItem, Menu } from "@material-ui/core";
import * as http from "modules/app/utils/http";
import { useParams } from "react-router";
import { toast } from "react-toastify";
import { useContacts } from "modules/app/contexts";
import _ from "lodash";
import { useTranslation } from "react-i18next";

function MessageHeader({ message, setAnswerMessage }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  // const { updateContactMessages } = useContacts();
  const { id } = useParams();
  const { t } = useTranslation();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  // function handleRemoveMessage() {
  //   http
  //     .deleteMessage(id, message.id)
  //     .then(() => {
  //       toast.success("Mensagem removida com sucesso");
  //       updateContactMessages({
  //         ...message,
  //         body: "Mensagem apagada",
  //       });
  //     })
  //     .catch(() => {
  //       toast.warn("Problema ao remover mensagem");
  //       updateContactMessages(message);
  //     });

  //   handleClose();
  // }

  function handleReplyMessage() {
    if (_.isEmpty(message.ack) || message?.ack?.email) {
      toast.info(t("Chat:messageHeader.replyDenied"));
      handleClose();
      return;
    }

    setAnswerMessage(message);
    handleClose();
  }

  return (
    <Header>
      <ExpandMoreIcon style={{ fontSize: "16px" }} onClick={handleClick} />

      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        <MenuItem onClick={handleReplyMessage}>
          {t("Chat:messageHeader.replyButton")}
        </MenuItem>

        {/* {message.from == "user" && (
          <MenuItem onClick={handleRemoveMessage}>Remover</MenuItem>
        )} */}
      </Menu>
    </Header>
  );
}

export default MessageHeader;
